import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/26ceb198-6454-4a0c-b3f2-f81ca8ba6b10.jpg';
export function Hero() {
  return <section id="accueil" className="relative w-full" data-id="element-104" data-mp="9lbkfd8rfxje">
      <div className="relative h-[70vh] min-h-[460px] w-full overflow-hidden" data-id="element-105" data-mp="4m8l89fgoljc">
        <img src={HERO_IMG} alt="Afdeling verse groenten en fruit in een A.D. INTER-groothandelsmagazijn" className="absolute inset-0 h-full w-full object-cover" data-id="element-106" data-mp="129h0hmovcycw" />
        <div className="absolute inset-0 bg-black/55" aria-hidden="true" data-id="element-107" data-mp="sb1axo5hpx5i" />

        <div className="relative mx-auto flex h-full max-w-4xl flex-col items-center justify-center px-4 text-center sm:px-6" data-id="element-108" data-mp="sde1gppbdfu6">
          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="font-display text-3xl font-extrabold leading-tight text-white drop-shadow-md sm:text-5xl md:text-6xl" data-id="element-109" data-mp="3d1aa1ojbgjfe">
            Uw partner voor bevoorrading
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.12
        }} className="mt-5 max-w-2xl text-base text-white/90 sm:text-lg" data-id="element-110" data-mp="39a38120t7hnu">
            Voeding, dranken, artikelen voor huis en elektronica — een ruim
            assortiment kwaliteitsproducten tegen scherpe prijzen.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.24
        }} data-id="element-111" data-mp="2hjf81tavgibr">
            <a href="#categories" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ardis-yellow px-7 py-3.5 text-sm font-semibold text-ardis-green-dark shadow-lg transition-transform hover:-translate-y-0.5 hover:bg-yellow-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black/50" data-id="element-112" data-mp="nbl3ooe6ymc1">
              Ontdek onze producten
              <ArrowRightIcon className="h-4 w-4" data-id="element-113" data-mp="162c8dcn8hok3" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}